import { TestDetailsRecord } from "@app/provider/types";

export const getNevaPreSessionToken = (
  testCard?: TestDetailsRecord
): string => {
  if (testCard?.nevaSessionToken) {
    return `upp_${testCard.nevaSessionToken}`;
  }
  return `lims_id_${testCard?.limsId?.toString()}`;
};
